// This file is used to map the fields for the NGL North Carolina Preneed Contract Form
import { getNGLFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/NGLFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'
import { usePaymentSetup } from '@/components/documents/Foxit/FormMapping/composables/PaymentFields'

export default class NGLNCPreneedContractForm {
	private fieldNameProvider = getNGLFieldNames()

	// Standard list of fields for this form.
	// These values point to field names in the fieldNameProvider, as well as functions to get the value for the field via the fieldValueProvider
	private fields: (keyof typeof this.fieldNameProvider)[] = [
		// FuneralHome
		'funeralHomeName',
		'funeralHomeFullAddress',
		'funeralHomeCity',
		'funeralHomeStreet',
		'funeralHomeState',
		'funeralHomeZip',

		// Insured
		'insuredFullName',
		'insuredAge',
		'insuredDateOfBirth',
		'insuredFullName',
		'insuredSSN',

		// Purchaser
		'purchaserFullName',
		'purchaserAddress',
		'purchaserCity',
		'purchaserState',
		'purchaserZip',

		// Payment
		'totalFaceAmount',
		'totalFirstPayment',
	]

	private unfilledFields = [
		'deathBenefit1',
		'deathBenefit2',
		'finalDispositionCrematedRemainsDesc',
		'insuranceCompany',
		'insuranceCompanyAddress',
		'insurancePolicyNumber',
		'policyOtherDesc',
		'policyOtherDesc1',
	]

	// Setup prior to building form filling array.
	constructor(planHolderId: string) {
		const { setFieldNameProvider } = useFormFillHelper()
		const { identitySetup } = useIdentitySetup()
		const { paymentSetup } = usePaymentSetup()

		setFieldNameProvider(this.fieldNameProvider)
		identitySetup(planHolderId, ['planHolder', 'funeralHome', 'salesContact'])
		paymentSetup(planHolderId, ['paymentDetails'])
	}

	// Build form filling array.
	getFormMappings() {
		const { formatFields, mapFields } = useFormFillHelper()

		const mainFields = mapFields(this.fields)

		return formatFields([...mainFields])
	}
}
